import http from '../../plugins/axios';

export default {

    queryCouponInfo(data){
        return http.get({
            url: '/admin/coupon/list',
            data
        })
    },

    addCoupon(data){
        return http.post({
            url: '/admin/coupon/add',
            data,
            dataType:'form'
        })
    },


    getNetValueList(data){
        return http.get({
            url: '/admin/fund/netValueList',
            data
        })
    },

    updateNetValue(data){
        return http.post({
            url: '/admin/fund/updateNetValue',
            data,
            dataType: 'form'
        })
    },

    projectNames(data){
        return http.get({
            url: '/admin/fund/projectNames',
            data,
        })
    },

    addNetValue(data){
        return http.post({
            url: '/admin/fund/addNetValue',
            data,
            dataType: 'form'
        })
    },
}
